var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$vuetify.breakpoint.mobile)?_c('div',[_c('desktop')],1):_vm._e(),(_vm.$vuetify.breakpoint.mobile)?_c('div',[_c('mobile')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }